/* eslint-disable max-classes-per-file */

export class NotFoundError extends Error {
  constructor(error, message) {
    super(error);
    this.name = "NotFoundError";
    this.message = message;
  }
}

export class BadRequestError extends Error {
  constructor(error, message) {
    super(error);
    this.name = "BadRequestError";
    this.message = message;
  }
}

export class ServerNetworkError extends Error {
  constructor(error, message) {
    super(error);
    this.name = "ServerNetworkError";
    this.message = message;
  }
}

export class ClinvarTokenError extends Error {
  constructor(message) {
    super(message);
    this.name = "ClinvarTokenError";
  }
}

export class ClinvarFormError extends Error {
  constructor(message) {
    super(message);
    this.name = "ClinvarFormError";
  }
}

export class ClinvarApiError extends Error {
  constructor(message) {
    super(message);
    this.name = "ClinvarApiError";
  }
}
